import type { ChainId } from '@morpho-org/blue-sdk'
import type { parseApiAsset } from '@morpho-org/dapp-core'
import type { Address } from 'viem'

export const PAGE_SIZE = 5

/** The vault asset every row's deposit is formatted and priced in, as `parseApiAsset` reads it. */
export type DistributionAsset = Parameters<typeof parseApiAsset>[0]

export interface VaultDistributionTableRow {
  chainId: ChainId
  user: { address: Address }
  token: ReturnType<typeof parseApiAsset>
  assets: bigint
  amountUsd: bigint | null | undefined
  sharePercentage: {
    /** The holder's WAD share of the supply; null when the vault's total supply is unknown. */
    value: bigint | null
    percentageOffset: bigint
  }
}
